module.exports = __webpack_public_path__ + "img/stock6.6c63bd51.png";